export const Endpoints = {
  login: `/api/v4/auth/login`,
  signUp: `/api/v4/auth/signup`,
  shortSignUp: `/api/v4/auth/signup/temp`,
  googleOneTap: `/api/v4/auth/google-one-tap`,
  forgotPasswordSendEmail: `/api/v4/auth/password/forget_request`,
  forgotPasswordCheckOtp: `/api/v4/auth/password/confirm_otp`,
  forgotPasswordResetPassword: `/api/v4/auth/password/confirm_reset`,
  logOut: `/api/v4/auth/logout`,
  getAllAddresses: `/api/v4/user/shipping/address`,
  getAllCountries: `/api/v4/countries`,
  getStates: `/api/v4/states-by-country`,
  getCities: `/api/v4/cities-by-state`,
  createAddress: `api/v4/user/shipping/create`,
  updateAddress: `api/v4/user/shipping/update`,
  deleteAddress: `api/v4/user/shipping/delete`,
  getUser: `api/v4/auth/user`,
  updateProfileImage: `api/v4/profile/update-image`,
  updateDefaultAddress: `api/v4/user/shipping/make_default`,
  updateProfile: `api/v4/profile/update`,
  getAllOrderHistory: `api/v4/purchase-history`,
  getAllInAppOrderHistory: `api/v4/digital/in-app-purchased-list`,
  getInAppOrderDetails: `api/v4/digital/in-app-purchased-details`,
  orderCancel: `api/v4/order-cancel-requests`,
  createCity: `api/v4/cities`,
  updateUserPhone: `api/v4/update-phone`,

  getOrderDetails: `/api/v4/purchase-history-details`,
  getCartDetails: `/api/v4/carts`,
  mergeAllCarts: `/api/v4/carts/merge-all`,
  getAllProducts: `/api/v4/products`,
  addToCart: `/api/v4/carts/add`,
  getCartCount: `/api/v4/cart-count`,
  updateQuantity: `/api/v4/carts/change-quantity`,
  emailExist: `/api/v4/auth/email-exist`,
  syncCart: `/api/v4/carts/user-assign`,
  cartSummary: `/api/v4/cart-summary`,
  applyCoupon: `/api/v4/coupon-apply`,
  updateCartAddress: `/api/v4/update-address-in-cart`,
  placeOrder: `/api/v4/order/store`,
  placePreOrder: `/api/v4/preorder/store`,
  razorpayPayment: `/api/v4/razorpay/payment`,
  orderDetails: `/api/v4/order`,
  productDetails: `/api/v4/products/slug`,
  productDetail: `/api/v4/products`,
  removeCoupon: `/api/v4/coupon-remove`,
  checkCoupon: `/api/v4/coupon-check`,
  bookMetaData: `/api/v4/products/metadata/slug`,
  contactUs: `/api/v4/contact-us`,
  paymentFailed: `/api/v4/razorpay/payment/failure`,
  convertToCod: `/api/v4/order/complete-with-cod`,
  hardcopyUpgradeCheckOffer: `/api/v4/hardcopy-upgrade/check-offer`,
  hardcopyUpgradeCreateOrder: `/api/v4/hardcopy-upgrade/create-order`,
  orderByHash: (hash: string) => `/api/v4/order-by-hash/${encodeURIComponent(hash)}`,
  orderInfoByHash: (hash: string) => `/api/v4/get-order-info/${encodeURIComponent(hash)}`,
  orderPaymentVerifyByHash: (hash: string) => `/api/v4/order-payment-verify/${encodeURIComponent(hash)}`,
  recentlyViewed: `/api/v2/recently-viewed`,
  recentlyViewedProducts: `/api/v2/recently-viewed-products`,

  invoice: `/api/v4/invoice/download`,
  subscribe: `/api/v4/subscribe`,
  plans: `/api/v4/plans`,
  applySubscriptionOffer: `/api/v4/subscription/apply-offer`,

  syncOrder: `/api/v4/order/sync`,
  syncOrderInApp: `/api/v4/order/in-app-sync`,

  updateAddressOnBlur: `api/v4/temp-cart-users`,
  getTempCartUser: (id: string | number) => `api/v4/temp-cart-users/${id}`,

  // krishna's changes
  resetPassword: `/api/v4/password/change_password`,

  // library pdf
  getAllBooks: `api/v2/books`,
  getAllOrangesBooks: `api/v2/oranges`,
  getAllOrangesCategories: `api/v2/oranges/categories`,
  getAllBundles: `api/v2/bundle`,
  getAllBundleCategories: `api/v2/bundle/categories`,
  getAllShortBooks: `api/v2/books/shorts`,
  getMyBooks: `api/v2/my-book`,
  getAuthorBooks: `api/v2/books`,
  getCoverImagesForBooks: `api/v2/books/cover-file`,
  getCoverImagesForBundle: `api/v2/bundle/cover-file`,
  getSampleFileForBooks: `api/v2/books/sample-file`,
  getSampleFileForBooksByProductId: `api/v2/books/sample-file/productId`,
  getAllChapters: `api/v2/chapters`,
  getChapterFile: `api/v2/chapters/file-stream`,
  getBookmarksList: `api/v2/bookmarks`,
  myBookSyncList: `api/v2/my-book/sync`,
  getSampleBook: `api/v2/books/sample-file-stream`,
  getBookDetailsBySlug: `api/v2/books/details`,
  getBookToken: `api/v2/auth/file-token`,
  postReadingLogs: `api/v2/reading-logs`,
  createSecret: `api/v2/webhook/appwrite/create-secret`,

  // courses
  getAllCourses: '/api/v2/v2/get/all-courses',
  getMyCourses: '/api/v2/v2/get/my-courses',
  getAuthorCourses: '/api/v2/v2/get/all-courses',
  coursesAllCategories: `/api/v2/v2/get/categories?unique=1`,
  syncCourses: `/api/v2/v2/my-courses/sync`,
  //schools
  readingHistory: `/public_api/schools/reading-history`,
  readingHistoryUpdate: `/public_api/schools/reading-history`,

  // Author
  authorProfile: `public_api/author`,
  featuredProfile: `/public_api/author-featured`,
  authorSchools: `/public_api/school`,
  authorLive: `public_api/zl-lives-by-author-id`,
  authorProfileV2: `/api/v2/author-profile`,

  //  Live
  getCurrentLive: '/public_api/zl-lives',
  getSingleOngoingLive: '/public_api/zl-lives-current-single',

  getUpcomingLive: '/public_api/get-upcoming-live',
  getLiveDetails: '/public_api/zl-lives/',
  getLiveSessionById: '/public_api/live-work-shop-sessions',
  getSessionCommentBySessionId: '/public_api/zl-comments/',
  postComment: '/api/v2/zl-comments',
  register: '/public_api/live-registration',
  getLiveBanner: '/public_api/live-work-shops',
  registerStatus: `/public_api/already-registered`,
  liveRegistrationAlreadyRegistered: `/public_api/zl-live-registration`,

  //Chat
  getThreads: `/api/v4/chat-threads`,
  getChatCount: `/api/v4/chat-count`,

  //Affiliate
  linkClick: `/api/v2/affiliate/link-clicked`,
  affiliateCode: `/api/v4/affiliate-customers`,

  // Book Categories
  getAllBookCategories: `/api/v2/categories`,
  getBookCategoriesByName: `/api/v2/categories/name`,

  getAllOnboardingCategories: `/api/v2/personality-test/category`,

  // AppWrite Api
  appWriteUser: `/api/v4/auth/appwrite-user`,

  // Temp-user Iframe
  tempUser: `/api/v4/temp-users`,
  checkAffiliateCode: `/api/v4/affiliate/code-check`,

  // firebase
  fireBaseTokens: `/api/v4/fire-base-tokens`,

  // Notifications
  notifications: `/api/v2/user-notification`,
  firebaseTokenNotification: `/api/v2/firebase-token`,
  deleteFireBaseToken: `/api/v2/firebase-token-delete`,
  userSyncNotification: `/api/v2/appwrite-user`,

  // Banner
  allBannerPages: `/api/v2/banner-page`,
  allBanners: `/api/v2/banner`,
  getBannersByRoute: `/api/v2/banner/route/details`,

  // Landing Page
  getLandingPageData: `/api/v2/landing-page/slug-heal`,
  getLandingPageSeoData: `/api/v2/seo`,
  getBookRecourses: `/api/v2/books/resource`,

  getCourseLandingPageData: `/api/v2/landing-page`,

  // Avatar Image
  getAuthorAvatar: `/api/v2/authors/avatar`,

  // Subscribe Coming soon books
  comingSoonSubscribe: `/api/v2/subscribe`,

  //School
  likesSchool: `api/v2/likes`,

  followAuthor: `api/v2/author-followers`,

  // Ai Chat
  askQuestion: `/api/ask_question`,
  askQuestionHistory: `/api/get_session_list`,
  getPrompts: `/api/suggested_queries`,
  getSessionMessages: `/api/get_session_messages`,
  responseFeedback: '/api/response_feedback',
  updateSessionTitle: '/api/update_session_title',
  deleteSession: '/api/delete_session',

  // Reviews
  getAllProductReviews: `api/v2/review`,
  getAllProductCourseReviews: `api/v2/review`,

  getUserProductReview: `api/v2/review/user`,
  checkIsPurchased: `api/v4/is-purchased`,

  // Personality Test
  getAllCategory: `api/v2/personality-test/category`,
  questions: 'api/v2/personality-test/question',
  options: 'api/v2/personality-test/option',
  deleteOption: 'api/v2/personality-test/option',
  getUserSubmission: 'api/v2/personality-test/user-submission/users',
  submitResponse: `api/v2/personality-test/user-submission`,
  getResultData: `api/v2/personality-test/results`,

  // Reward
  claimReward: `api/v4/order/claim_product`,
  walletTransactions: `api/v4/wallet/transactions`,
  inviteFriend: `api/v4/invite-users`,
  getRewardRule: `api/v4/get-reward-value`,
  invitedUser: `api/v4/user/referrals`,
  getAllRewards: `api/v4/user-rewards`,
  claimRewardDynamic: `api/v4/claim-reward`,

  //onboarding-response
  submitOnboardingResponse: `api/v2/onboarding-user-submission`,
  resultOnboardingResponse: `api/v2/onboarding-user-submission/result`,

  // Get Author
  getAuthorByZl_uid: `public_api/author_by_zl_uid`,

  // Stream Book
  getCompleteBookByBookId_Stream: `api/v2/books/complete-book-stream-protected`,
  getCompleteAudioBookByBookId_Stream: `api/v2/books/complete-book-audio`,
  getSampleAudioBookByBookId_Stream: `api/v2/books/sample-book-audio`,

  getChapterVideoStream: `api/v2/chapters`,
  getPdfJobStatus: `api/v2/books/pdf-status`,

  sendFeedback: `api/v4/contact-us`,

  checkHasNewBook: `api/v2/users/has-new-product`,

  startSubscription: `api/v4/start-subscription`,
  verifySubscription: `api/v4/verify-payment-subscription`,
  userConsumable: `api/v4/user-consumable`,
  subscribeProduct: 'api/v4/subscribe_product',
  checkSubscription: 'api/v4/check-subscription',
  plansOffer: 'api/v4/plans-offer',
  subscriptionCancel: 'api/v4/subscription-cancel',

  // Pdf Notes
  pdfNotes: 'api/v2/notes',
  // Amazon Order
  checkAmazonOrderId: `api/v4/amazon-order/check`,
  syncAmazonOrderId: `api/v4/amazon-order/sync`,

  // courses
  getCourseReaderList: `/api/v2/landing-page/courses`,
  requestCallBack: `/api/v4/product-leads`,
  checkCallBackRequest: `/api/v4/product-leads/check`,
  getCourseBySlug: (slug: string) => `/api/v2/course/${slug}`,
  getResources: (topicId: string | number) => `/api/v2/resource/${topicId}`,
  readFileUrl: `/api/v2/s3/get-presigned-url/get-object`,
  userTrackHandle: `/api/v2/track/make`,
  updateDuration: `/api/v2/my-course/duration`,
  getCertificate: `/api/v2/certificate/generate`,

  // globalLogs
  globalFrontendErrorLogs: '/api/v2/frontend-logs',

  // Coupon
  getAllCoupons: `/api/v2/coupon`,

  // Razorpay Data
  getRazorpayHashKeyData: `/api/v4/get-order-info`,
  getRazorpayHashKeyVerify: `/api/v4/order-payment-verify`,

  // Razorpay Subscription
  getSubscriptionInfo: `/api/v4/get-subscription-info`,
  subscriptionPaymentVerify: `/api/v4/subscription-payment-verify`,

  // Retry Lambda
  retryPdfJob: `api/v2/books/pdf-job/retry`,

  // Active Countries
  activeCountries: `/api/v4/active-countries`,

  productAccessCheck: (productId: string) =>
    `/api/v4/products/${productId}/access/check`,
  productAccessEnroll: (productId: string) =>
    `/api/v4/products/${productId}/access/enroll`,

  // Onboarding
  getOnboarding: `/api/v4/on_boarding_steps`,
  saveOnboardingAnswer: `/api/v4/on_boarding_answer`,

  store: {
    getAll: '/api/v2/store',
    getStoreImage: (id: string) => '/api/v2/store/image/' + id,
  },

  getAllBestsellerSpotlight: '/api/v2/bestseller-spotlight',
  getAllShowcaseShortVideo: '/api/v2/showcase-short-video',
  selfPublishingLeads: '/api/v2/self-publishing-leads',

  // Route Banner
  routeBanners: '/api/v2/route-banner',
  getRouteBanner: '/api/v2/route-banner/route',
  updateRouteBanner: (id: string) => `/api/v2/route-banner/${id}`,
  deleteRouteBanner: (id: string) => `/api/v2/route-banner/${id}`,

  // Route Popup
  getRoutePopup: '/api/v2/route-popup/route',

  // Organization Credit & Wallet System (V4)
  organization: {
    me: '/api/v4/organization/me',
    details: '/api/v4/organization',
    dashboard: '/api/v4/organization/dashboard',
    spending: '/api/v4/organization/spending',
    activity: '/api/v4/organization/activity',
    leaderboard: '/api/v4/organization/leaderboard',
    leads: '/api/v4/organization-leads',

    // Onboarding
    checkName: '/api/v4/organization/onboarding/check-name',
    setupProfile: '/api/v4/organization/onboarding/setup-profile',
    step1: '/api/v4/organization/onboarding/step1',
    step2: '/api/v4/organization/onboarding/step2',
    step3: '/api/v4/organization/onboarding/step3',
    onboarding: '/api/v4/organization/onboarding',

    // Invitations & Joining
    validateInvitation: '/api/v4/organization-invitations/validate',
    validateInvitationToken: (token: string) =>
      `/api/v4/organization-invitations/${token}`,
    acceptInvitation: '/api/v4/organization-invitations/accept',
    acceptInvitationToken: (token: string) =>
      `/api/v4/organization-invitations/${token}/accept`,
    joinByCode: (code: string) => `/api/v4/organization-join/${code}`,

    // Members Management
    members: '/api/v4/organization/members',
    inviteMember: '/api/v4/organization/members/invite',
    bulkInvite: '/api/v4/organization/members/bulk-invite',
    bulkInviteCsv: '/api/v4/organization/members/bulk-invite-csv',
    sampleCsv: '/api/v4/organization/members/sample-csv',
    reinviteMember: (memberId: string | number) =>
      `/api/v4/organization/members/${memberId}/reinvite`,
    memberLimit: (memberId: string | number) =>
      `/api/v4/organization/members/${memberId}/limit`,
    memberById: (memberId: string | number) =>
      `/api/v4/organization/members/${memberId}`,

    // Wallet & Recharges
    wallet: '/api/v4/organization/wallet',
    walletLedger: '/api/v4/organization/wallet/ledger',
    walletRecharges: '/api/v4/organization/wallet/recharges',
    rechargeInitiate: '/api/v4/organization/recharge/initiate',
    rechargeVerify: '/api/v4/organization/recharge/verify',
    requestTopUp: '/api/v4/organization/request-top-up',

    // Purchasing & Quotes
    purchaseQuote: '/api/v4/organization/purchase/quote',
    purchase: '/api/v4/organization/purchase',

    // Documents Management
    documents: '/api/v4/organization/documents',
    documentById: (id: string | number) =>
      `/api/v4/organization/documents/${id}`,
  },
};
